import { useMutation, useQueryClient } from '@tanstack/react-query';
import { queryKeys, domainsService } from '@v2/services';

export const useDeleteDomain = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: domainsService.deleteDomain,
    onSuccess: () => {
      queryClient.invalidateQueries(queryKeys.domains.all);
      queryClient.invalidateQueries(queryKeys.partners.all);
    },
  });

  const deleteDomain = async (domainId: string): Promise<boolean> => {
    try {
      await mutation.mutateAsync(domainId);
      return true;
    } catch {
      return false;
    }
  };

  return {
    deleteDomain,
    loading: mutation.isLoading,
    error: mutation.error instanceof Error ? mutation.error.message : null,
  };
};

export default useDeleteDomain;
